import request from '@/utils/request'
/**
 * 申请信息
 * @param {*} data
 */
export const addAssurance = data => request().post('assurance/apply/page', data)
// 下载附件
export const downUpload = id => request().get(`assurance/download/${id}`)

// 下载查询内容
export const download = data =>
  request().post('assurance/apply/export', data, {
    responseType: 'blob',
  })
